import React from "react";
import { NavLink } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import HomeIcon from '@mui/icons-material/Home';
import { useBreadcrumb } from './breadcrumb-context';

function Breadcrumb() {
    const { breadcrumbs } = useBreadcrumb();

    return (
      <Breadcrumbs 
        aria-label="breadcrumb" 
        separator={<NavigateNextIcon fontSize="small" sx={{ color: 'text.disabled' }} />}
        sx={{ 
            '& .MuiBreadcrumbs-ol': { alignItems: 'center' },
            backgroundColor: 'rgba(0, 0, 0, 0.03)',
            px: 2,
            py: 0.5,
            borderRadius: 2,
            display: 'inline-flex'
        }}
      >
        <Link
          component={NavLink}
          to="/"
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            color: 'text.secondary',
            textDecoration: 'none',
            fontSize: '0.85rem',
            '&:hover': { 
                color: 'success.main',
                textDecoration: 'underline'
            }
          }}
        >
          <HomeIcon sx={{ mr: 0.5, fontSize: '1.1rem' }} />
          LMS
        </Link>

        {breadcrumbs.map(({ label, path }, index) => {
          const last = index === breadcrumbs.length - 1;
  
          return last ? (
            <Typography 
              key={path}
              sx={{ 
                color: 'text.primary', 
                fontWeight: 600, 
                fontSize: '0.85rem' 
              }}
            >
              {label}
            </Typography>
          ) : (
            <Link 
              component={NavLink} 
              to={path} 
              key={path}
              sx={{ 
                color: 'text.secondary', 
                textDecoration: 'none',
                fontSize: '0.85rem',
                '&:hover': { 
                    color: 'success.main',
                    textDecoration: 'underline'
                }
              }}
            >
              {label}
            </Link>
          );
        })}
      </Breadcrumbs>
    );
}

export default Breadcrumb;